import axios from 'axios';
import config from '../../config';
import { getAxiosConfigUserToken } from 'app/utils/appHelpers';
// import { getAxiosConfigUserToken } from 'app/utils/appHelpers';
// import { createAsyncThunk } from '@reduxjs/toolkit';

export const getUserByRoleIdAndInstApi = async (roleId, inst) => {
   const url = `${config.apiUrl}/v1/user/byUserRoleIdAndInst/${roleId}/${inst}`;
   return await axios.get(url, getAxiosConfigUserToken())
      .then(response => response.data).catch(err => { return { status: false, error: err.response } });
}

export const getUserByRoleIdAndInstArrayApi = async (roleId, instArray) => {
   const url = `${config.apiUrl}/v1/user/byUserRoleIdAndInstArray/${roleId}/${instArray}`;
   return await axios.get(url, getAxiosConfigUserToken())
      .then(response => response.data).catch(err => { return { status: false, error: err.response } });
}

export const postCreateUserApi = async (user) => {
   const url = `${config.userAuthApiUrl}/v1/user/newUser/otherApp`;
   return await axios.post(url, user, getAxiosConfigUserToken())
      .then(response => response.data)
}

export const postSaveUserRoleApi = async (userRole) => {
   const url = `${config.apiUrl}/v1/user/saveUserRole/`;
   return await axios.post(url, userRole, getAxiosConfigUserToken())
      .then(response => response.data)
}

export const deleteUserRoleApi = async (userRole) => {
   const url = `${config.apiUrl}/v1/user/deleteUserRole/`;
   return await axios.post(url, userRole, getAxiosConfigUserToken())
      .then(response => response.data)
}

export const getAllInstUsersApi = async () => {
   const url = `${config.apiUrl}/v1/user/allInstUsers`;
   return await axios.get(url, getAxiosConfigUserToken())
      .then(response => response.data)
}

export const getFilteredUsersApi = async () => {
   const url = `${config.apiUrl}/v1/user/filteredUsers/`;
   return await axios.get(url, getAxiosConfigUserToken())
      .then(response => response.data)
}

export const getAuthorizedUnitsFromUserIdApi = async (userId) => {
   const url = `${config.apiUrl}/v1/user/authorizedUnitsFromUserId/${userId}`;
   return await axios.get(url, getAxiosConfigUserToken())
      .then(response => response.data)
}

export const getReadAuthorizedUnitsFromUserIdApi = async (userId) => {
   const url = `${config.apiUrl}/v1/user/readAuthorizedUnitsFromUserId/${userId}`;
   return await axios.get(url, getAxiosConfigUserToken())
      .then(response => response.data)
}
